import { render, staticRenderFns } from "./QSEALCertificate.vue?vue&type=template&id=2a49d79f&"
import script from "./QSEALCertificate.vue?vue&type=script&lang=js&"
export * from "./QSEALCertificate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports